<template>
  <div class="product warp">
    <div class="main">
      <div class="table">
        <el-table v-loading="loading"  :data="tableData" border style="width: 100%">
          <el-table-column align="center"  width="200" prop="server_number" label="申请单号"> </el-table-column>
          <el-table-column align="center" width="200" prop="order_child_sn" label="订单编号"></el-table-column>
          <el-table-column align="center" width="200" prop="order_child_goods_sn" label="商品订单编号"></el-table-column>
          <el-table-column align="center" width="150" prop="apply_time" label="申请时间"></el-table-column>
          <el-table-column align="center" width="150" prop="user_name" label="用户账号"></el-table-column>
          <el-table-column align="center" width="150" prop="price_order" label="订单金额"></el-table-column>
          <el-table-column align="center" width="150" prop="pay_price" label="退款金额"></el-table-column>
          <el-table-column align="center" width="150" prop="order_status" label="发货状态">
            <template slot-scope="scope">
              <span>{{
                  scope.row.order_status == 1
                  ? "待付款"
                  : scope.row.order_status == 2
                  ? "待发货"
                  : scope.row.order_status == 3
                  ? "待收货"
                  : scope.row.order_status == 4
                  ? "待评论"
                  : scope.row.order_status == 5
                  ? "已取消"
                  : scope.row.order_status == 6
                  ? "已完成"
                  : scope.row.order_status == 7
                  ? "已取消"
                  : "-"}}
              </span>
            </template>
          </el-table-column>
          <el-table-column v-if="status=='0'" align="center" width="150" label="申请状态">
            <template slot-scope="scope">
              <span>{{
                  scope.row.status == 1
                  ? "待处理"
                  : scope.row.status == 2
                  ? "已处理"
                  : scope.row.status == 3
                  ? "已拒绝"
                  : scope.row.status == 4?
                   "已取消": "-"}}
              </span>
            </template>
          </el-table-column>
          <el-table-column align="center" width="200"  prop="handling_time" label="处理时间"></el-table-column>
          <el-table-column align="center" width="200" fixed="right" label="操作">
            <template slot-scope="scope">
              <span>
                <el-link type="primary" @click="hides(scope.row.server_number,scope.row.status)">详情</el-link>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <div class="page">
          <el-pagination @size-change="sizeChange"
              @current-change="handleSizeChange"
              background 
              :current-page="page"
              :page-sizes="[10, 20, 30, 40]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions} from "vuex";
export default {
  name: "product",
  data () {
    return {
      tableData: [],//报个数据
      dialogFormVisible: false, //
      loading: false, //是都展示loading
      page:1,//分页的页数
      limit:10,//分页的每页多少
      total:0,//当前列表的总数
      shopIDList:[],//商家店铺的ID列表
      // orderchildsn:"",//退款订单编号
      // status:1,//退款状态
    };
  },
  props: {
    orderchildsn:{
      type:String,
    },
    server_number:{
      type:String,
    },
    status:{
      type:String,
    }
  },
  filters: {
  },
  mounted () { 
    let shopIDList = JSON.parse(localStorage.getItem("shop")).shop;
    let arr=[]
        shopIDList.forEach((item) => {
            arr.push(item.shop_id);
        });
    this.shopIDList=arr.join()
    this.getRefundList(1)
  },
  methods: {
    ...mapActions({
      QueryReturnedPurchase:"commodity/QueryReturnedPurchase"
    }),
    getRefundList(){
      let params={
          shop_ids:this.shopIDList?this.shopIDList:-1,
          // user_name:JSON.parse(localStorage.getItem("vuex")).userInfo.operator_cellphone,
          // refunds_type:this.refunds_type,//退货所需
          server_number:this.server_number,
          Status:this.status,
          refunds_type:2,
          order_child_goods_sn:this.orderchildsn,
          PageIndex:this.page,
          PageSize:this.limit,
      }
      this.QueryReturnedPurchase(params).then(res=>{
        if(res.code===0){
          this.tableData=res.data
          res.data.forEach(item => {
            let reg = /^(.{3}).*(.{4})$/
            item.user_name=item.user_name.replace(reg, '$1****$2')
          })
          this.total=res.total
          this.$forceUpdate();
        }else{
          this.$message.error(res.msg);
        }
      })
    },
    sizeChange(val){
        this.limit=val
        this.getRefundList()
    },
    handleSizeChange(val){
        this.page=val
        this.getRefundList()
    },
    hides (id,status) {
      this.$router.push({ 
        path: `/home/retunPudDetail`,
        query: {
          orderChildGoodsSn: id,
          status:status
        }
      });            
    },
    ExportWord(){
      this.getExcel(this.tableData)
    },
    getExcel(arr) {
      require.ensure([], () => {
        const { export_json_to_excel } = require("../../../../excel/Export2Excel.js");
        const tHeader = [
            "申请单号",
            "订单编号",
            "商品订单编号",
            "申请时间",
            "用户账号",
            "订单金额",
            "退款金额",
            "发货状态",
            "申请状态",
            "处理时间"
        ];
        const filterVal = [
            "server_number",
            "order_child_sn",
            "order_child_goods_sn",
            "apply_time",
            "user_name",
            "price_order",
            "pay_price",
            "order_status",
            "status",
            "handling_time",
        ];
        const data = this.formatJson(filterVal, arr);
        export_json_to_excel(tHeader, data, "订单管理数据");
        this.disbtn = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
  },
};
</script>
<style lang='scss' scoped>
.shop_table{
  ::v-deep th{
    border: none;
  }
}
::v-deep .el-table__header .has-gutter{
  .el-table__cell .gutter{
    width: 0;
  }
} 
::v-deep .el-date-editor .el-range-separator {
  padding: 0;
}
.product {
  .main {
    .table {
      overflow: hidden;
      overflow-x: auto;
      margin-top: 20px;
      .page {
        margin-top: 20px;
        float: right;
      }
    }
  }
}
::v-deep .el-table .el-table__fixed-right {
  width: 199px !important;
}
.link span {
  margin: 0 8px;
}
</style>